import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Slider, TextField } from '@mui/material';

interface RidePatternSliderProps {
  ridePattern: { p2p: number; p2h: number; h2h: number };
  setRidePattern: (pattern: { p2p: number; p2h: number; h2h: number }) => void;
}

const RidePatternSlider: React.FC<RidePatternSliderProps> = ({ ridePattern, setRidePattern }) => {
  const { t } = useTranslation('mapWizards');
  // Use a two-thumb slider for three segments
  const values = [ridePattern.p2p, ridePattern.p2p + ridePattern.p2h];

  const handleSliderChange = (_: any, newValue: number | number[]) => {
    if (!Array.isArray(newValue)) return;
    const [p2p, p2pPlusP2h] = newValue;
    const p2h = p2pPlusP2h - p2p;
    const h2h = 100 - p2pPlusP2h;
    setRidePattern({
      p2p: Math.round(p2p),
      p2h: Math.round(p2h),
      h2h: Math.round(h2h),
    });
  };

  return (
    <Box sx={{ mt: 3, mb: 2 }}>
      <Typography variant="subtitle1">{t('generateRides.ridePattern.title')}</Typography>
      <Typography variant="body2" sx={{ mb: 1 }}>
        {t('generateRides.ridePattern.descriptionShort')}
      </Typography>
      <Slider
        value={values}
        onChange={handleSliderChange}
        min={0}
        max={100}
        step={1}
        valueLabelDisplay="auto"
        marks={[
          { value: 0, label: '0%' },
          { value: 100, label: '100%' },
        ]}
      />
      <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
        <TextField
          label={t('generateRides.ridePattern.p2pLabel')}
          value={ridePattern.p2p}
          size="small"
          inputProps={{ readOnly: true }}
        />
        <TextField
          label={t('generateRides.ridePattern.p2hLabel')}
          value={ridePattern.p2h}
          size="small"
          inputProps={{ readOnly: true }}
        />
        <TextField
          label={t('generateRides.ridePattern.h2hLabel')}
          value={ridePattern.h2h}
          size="small"
          inputProps={{ readOnly: true }}
        />
      </Box>
    </Box>
  );
};

export default RidePatternSlider; 